var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export const createBlock = (_a) => {
    var { Wrapper, Component } = _a, blockProps = __rest(_a, ["Wrapper", "Component"]);
    return (_a) => {
        var { children } = _a, props = __rest(_a, ["children"]);
        return Wrapper ? (_jsx(Wrapper, Object.assign({}, blockProps, { Component: Component, componentChildren: children, componentProps: props }), void 0)) : (_jsx(Component, Object.assign({}, props, { children: children }), void 0));
    };
};
//# sourceMappingURL=blocks.js.map